// react and mui stuff
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import Avatar from '@mui/joy/Avatar'
import Sheet from '@mui/joy/Sheet'
import Skeleton from '@mui/joy/Skeleton'
import Typography from '@mui/joy/Typography'
import { SxProps } from "@mui/joy/styles/types";

// data and stuff
import { BaseUser } from "../types/users";
import { UserContext } from "../utils/contexts";

export default function UserCard (props: { profile: Exclude<BaseUser, null>, customName?: string, sx?: SxProps, loading: boolean, setProfile?: Function, small?: boolean }) {
  const nav = useNavigate()
  const mainUser = useContext(UserContext)
  const invalidClicker = props.loading || props.profile.id === mainUser.user?.id || !props.profile.id || props.profile.id === "000"
  return (
    <Sheet
      variant="outlined"
      className="flexMidVert"
      sx={{borderRadius: "50px", paddingRight: "10px", cursor: invalidClicker ? "default" : "pointer", whiteSpace: "nowrap", minWidth: 0, ...props.sx }}
      onClick={() => {
        if (invalidClicker) return;
        if (props.setProfile) props.setProfile(undefined)
        nav(`/profile/${props.profile?.id}`)
    }}>
      <Avatar src={props.profile.avatar} alt={`${props.profile.displayName}'s avatar`} sx={{ marginRight: "10px" }} size={ props.small ? "sm" : undefined }>
        <Skeleton loading={props.loading}/>
      </Avatar>
      <Typography sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }} level={ props.small ? "body-sm" : undefined }><Skeleton loading={props.loading}>
        {props.customName && props.customName}
        {!props.customName && props.profile.displayName}
      </Skeleton></Typography>
    </Sheet>
  )
}